{
  "A summary of the practice's history for online scheduling requests.": "A summary of the practice's history for online scheduling requests.",
  "Accepted": "Accepted",
  "Appointment Date & Time": "Appointment Date & Time",
  "Appointment Outcome": "Appointment Outcome",
  "Appointment Type": "Appointment Type",
  "Calendar": "Calendar",
  "Cancelled": "Cancelled",
  "Completed": "Completed",
  "Confirmed": "Confirmed",
  "Contact Attempted": "Contact Attempted",
  "Dismissed": "Dismissed",
  "Done": "Done",
  "It looks like you don't have permission to view this page. Please contact your system administrator for more information.": "It looks like you don't have permission to view this page. Please contact your system administrator for more information.",
  "Next Page": "Next Page",
  "Origin": "Origin",
  "Pending": "Pending",
  "Previous Page": "Previous Page",
  "Recipient": "Recipient",
  "Refresh Data": "Refresh Data",
  "Rejected": "Rejected",
  "Requested Date": "Requested Date",
  "Review Date": "Review Date",
  "Reviewed By": "Reviewed By",
  "Rows per page": "Rows per page",
  "Schedule Request History": "Schedule Request History",
  "Service Type": "Service Type",
  "rows-per-page": "rows-per-page"
}
